export const TRANSFORM_TAB = 2;

export const FE_STRINGS = {
  header: {
    title: "Moteur de formulaire",
  },
  loading: {
    label: "Chargement des données...",
  },
  tabs: {
    aria: "Onglets de résultat",
    analyse: "Anomalies",
    interactive: "Formulaire",
    json: "JSON normalisé",
    output: "Post CardPro",
  },
  messages: {
    noJsonToCopy: "Aucun JSON à copier.",
    copyOk: "JSON copié dans le presse-papiers.",
    copyFail:
      "Impossible de copier le JSON. Vérifiez les permissions du navigateur.",
    interactiveHint:
      "Cliquez sur « Générer le formulaire » pour afficher le formulaire.",
  },
};
